module.exports = __webpack_public_path__ + "static/media/tampere.1638eccb.png";